import { FETCH_DAILY_BODY_BATTERY_REPORT, FETCH_BODY_BATTERY_EVENTS } from './ActionTypes';

export function fetchDailyBodyBatteryReport(payload) {
    return {
        type: FETCH_DAILY_BODY_BATTERY_REPORT,
        payload
    };
}

export function fetchBodyBatteryEvents(payload) {
    return {
        type: FETCH_BODY_BATTERY_EVENTS,
        payload
    };
}
